import React from 'react';
export var CrossIcon = function (_a) {
    var className = _a.className, _b = _a.width, width = _b === void 0 ? 14 : _b, _c = _a.height, height = _c === void 0 ? 14 : _c, _d = _a.color, color = _d === void 0 ? 'white' : _d;
    return (React.createElement("svg", { className: className, width: width, height: height, viewBox: "0 0 14 14" },
        React.createElement("path", { fill: color, fillOpacity: "1", d: "M14 1.41L12.59 0 7 5.59 1.41 0 0 1.41 5.59 7 0 12.59 1.41 14 7 8.41 12.59 14 14 12.59 8.41 7z" })));
};
